import { Role } from "../../../types/Role";
import { request } from "../../apiService";

export const getAllRoles = async () => {
    const response = await request<{ roles: Role[] }>("/admin/roles");
    return response?.roles ?? [];
};

export const updateUserRole = async (userId: string, role: string) => {
    return await request<void, { role: string }>(`/admin/users/${userId}/promote`, {
        method: "PUT",
        input: { role },
    });
};
